module.exports = __webpack_public_path__ + "img/TO12T.e47f1740.svg";